"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function RequestAFreeBoilerQuote() {
  return <section data-section-id="223313" id="request-a-free-boiler-quote" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex items-center justify-center">
      {}
      <style>
        {`
          @keyframes float-rotate {
            0%, 100% { transform: translateY(0) rotate(-5deg); }
            50% { transform: translateY(-20px) rotate(5deg); }
          }
          .animate-float-rotate {
            animation: float-rotate 12s ease-in-out infinite;
          }
        `}
      </style>

      {}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-10 pointer-events-none" />

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689081/img/dublin_plumbing_boiler_unit.png" alt="Modern Boiler Unit" className="animate-float-rotate max-w-[120%] md:max-w-4xl w-full object-contain opacity-10 blur-[1px] scale-110" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold mb-6 tracking-tighter text-balance text-primary">
          Request a Free Boiler Quote
        </h2>
        
        <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl mb-12 text-balance">
          Upgrade your home with a high-efficiency boiler installation. Our RGI registered experts provide professional surveys and competitive pricing across Dublin.
        </p>
        
        <div className="flex flex-col items-center gap-6">
          <Button asChild size="lg" className="rounded-lg px-8 h-14 text-lg group bg-primary hover:bg-primary/90 shadow-lg shadow-primary/20">
            <Link to="tel:+35319081819">
              Call 01 908 1819
              <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
          
          <Link to="/BoilerRepairPage" className="font-default text-sm font-medium text-destructive hover:underline transition-colors">
            Need an Emergency Repair instead? Click here.
          </Link>
        </div>
      </div>
    </section>;
}